import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrescriptorService } from '../../services/prescriptor.service';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { PrescriptorEditComponent } from '../prescriptor-edit/prescriptor-edit.component';
import { AdvancedLookupComponent } from '../../models/lookup';
import { fromEvent, of } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { InformeService } from '../../services/informe.service';

@Component({
  selector: 'app-prescriptor',
  templateUrl: './prescriptor.component.html',
  styleUrls: ['./prescriptor.component.scss']
})
export class PrescriptorComponent implements OnInit, AfterViewInit, AdvancedLookupComponent {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;
  public rowData: any;
  dialogConfig: MatDialogConfig;
  searchTerm: FormControl = new FormControl();
  @ViewChild('inputSearch', { static: false }) inputSearch!: ElementRef;

  constructor(private _PrescriptorService: PrescriptorService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog, _translateService: TranslateService, private informeService: InformeService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
    this.dialogConfig.width = '85vw';
    this.dialogConfig.maxHeight = '95vh';
    this.dialogConfig.height = '100%';
  }
  getSelectedItem() {
    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      const rowid = selectedRow.data.id;
      console.log(rowid);
      return rowid;

    } else {
      return null;
    }
  }

  createColumnDef() {
    const columnDefs = [
      // {
      //   headerName: '', checkboxSelection: true, headerCheckboxSelection: true, width: 50
      // },
      {
        headerName: 'Eliminar', field: 'id', suppressFilter: true, suppressSorting: true,
        template: `<a data-action-type="remove"><i data-action-type="remove" class="fa fa-remove text-danger"></i></a>`,
        width: 100
      },
      {
        headerName: 'Editar', field: 'id', cellClass: 'grid-opendialog',
        template: `<i class="fa fa-edit text-info"></i>`,
        width: 100
      },
      { headerName: this.translate.instant('prescriptor.id'), field: 'id', width: 100, minWidth: 150 },
      { headerName: this.translate.instant('prescriptor.descripcion'), field: 'descripcion', width: 200, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, width: 250, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', width: 250, minWidth: 150, suppressSizeToFit: false },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, width: 250, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', width: 250, minWidth: 150 },
    ]

    return columnDefs;
  }

  public defaultColDef = {
    width: 100,
    filter: 'agTextColumnFilter'
  };


  ngOnInit() {
    this._PrescriptorService.getPrescriptores('').subscribe({
      next: data => {
        this.rowData = data;
      },
      error: err => {
        console.error('Error al obtener prescriptores:', err);
      }
    });

  }

  ngAfterViewInit(): void {
    if (this.inputSearch) {
      this.inputSearch.nativeElement.focus();
      fromEvent(this.inputSearch.nativeElement, 'keyup')
        .pipe(
          debounceTime(400),
          switchMap((event: any) => {
            console.log(event.target.value);
            this.getData(event.target.value);
            return of(event.target.value);
          })
        )
        .subscribe(event => {
          console.log(event);
        });
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  private getData(search: string = '') {
    this._PrescriptorService.getPrescriptores(search).subscribe({
      next: data => {
        this.rowData = data;
      },
      error: err => {
        console.error('Error al obtener prescriptores:', err);
      }
    });
  }

  public newItem() {
    let ref = this._dialog.open(PrescriptorEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  public onCellClickedEvent($event) {
    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);
      }
    }
    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf("grid-opendialog") >= 0) {
      let dlgRef = this._dialog.open(PrescriptorEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this.getData();
      })
    }
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._PrescriptorService.delete(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Este prescriptor está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarlo como inactivo.");
        }
        this.getData();
      });
    }
  }

  onDownload() {
    this.informeService.getInformePrescriptores();
  }

}
